import { Component, Input } from '@angular/core';
import { EmployeeRecoveryStatsDTO } from '../../pages/atelier/service/atelier-controller.service';

@Component({
  selector: 'app-employee-recovery-stats',
  templateUrl: './employee-recovery-stats.component.html',
  styleUrls: ['./employee-recovery-stats.component.scss'],
})
export class EmployeeRecoveryStatsComponent {
  @Input() performanceList: EmployeeRecoveryStatsDTO[] = [];
}
